import React from "react";
import { History } from "history";
import { withRouter } from "react-router-dom";

type params = {
  history: History;
  children?: React.ReactNode;
}

function ScrollToTop({ history, children }: params) {
  React.useEffect(() => {
    const unlisten = history.listen(() => {
      // TODO: Figure out the right way to do this.
      // As is, we need to add a delay for it to work for the contact page for some reason.
      // This seems like a Firefox specific bug (at least it works on Chromium)
      // https://stackoverflow.com/questions/36904185/react-router-scroll-to-top-on-every-transition
      if (!history.location.hash) {
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 50);
      }
    });
    return () => {
      unlisten();
    };
  }, []);

  return <React.Fragment>{children}</React.Fragment>;
}

export default withRouter(ScrollToTop);